import './unpaid-invoices.scss';

import Conditional from "@/components/conditional";
import LoadableComponent from "@/components/loadable-component";
import { InvoiceContext } from "@/contexts/invoice-context";
import Invoice from "@/models/invoice";
import Payment from '@/models/payment';
import PaymentEvent from "@/models/payment-event";
import UnpaidInvoice from '@/models/unpaid-invoice';
import api from '@/services/api';
import invoiceApi from '@/services/apis/invoice/invoice-api';
import invoicePdfApi from "@/services/apis/invoice/invoice-pdf-api";
import paymentApi from "@/services/apis/payment/payment-api";
import { formatAsCurrency } from "@/services/formatters";
import { logException, logTrace } from '@/services/logging';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";
import { Card, CardBody, Row, Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

interface Props {
    
}

function UnpaidInvoices(props: Props) {
    const [unpaidInvoices, setUnpaidInvoices] = useState<UnpaidInvoice[]>([]);
    const [invoice, setInvoice] = useState<Invoice>();
    const navigate = useNavigate();

    const invoiceContext = useContext(InvoiceContext);

    useEffect(() => {
        setInvoice(invoiceContext.invoice);
        invoiceApi.getUnpaidInvoices(setUnpaidInvoices);
    }, [invoiceContext.invoice]);

    return (
        <>
        {!!unpaidInvoices && unpaidInvoices.length > 0 && <Card className='f-card f-unpaid-invoices'>
            <CardBody>
                <Row className="f-header-link">
                    <h3><b>{`Unpaid invoices for ${invoice?.ProjectName}`}</b></h3>
                </Row>
                <Row>
                    <Table striped hover>
                        <thead>
                            <tr>
                                <th>Invoice Number</th>
                                <th>Date</th>
                                <th>Amount</th>
                                <th>Payment Link</th>
                            </tr>
                        </thead>
                        <tbody>
                            {unpaidInvoices.map((invoice, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{invoice.InvoiceNumber}</td>
                                        <td>{invoice.Date}</td>
                                        <td>{formatAsCurrency(invoice.Amount)}</td>
                                        <td>
                                            <Link target='_blank' to={invoice.PayLink}>
                                                Pay Invoice <FontAwesomeIcon icon="external-link"></FontAwesomeIcon>
                                            </Link>
                                        </td>
                                    </tr>)
                            })}
                        </tbody>
                    </Table>
                </Row>
            </CardBody>
        </Card>}
        </>
    )
}

export default UnpaidInvoices;